export const defaultHeaders: HeadersInit = {
    'content-type': 'application/json',
    accept: 'application/json',
};
